export default "__VITE_ASSET__DSa4_y9B__"